export const apiEndPoint =
  "https://torrescontenedoresapi-testing.hmhsistemas.com.mx/api/";
